import React from 'react';
import 'twin.macro';
import { WorkingDaysSelector } from 'components/WorkingDaysSelector';
import { Classroom } from 'types/classroom';
import useUpdateClassroom from 'queries/classrooms/useUpdateClassroom';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';

interface Props {
  classroom: Classroom;
  index: number;
  classrooms: Classroom[];
}

export function ClassroomConfiguration(props: Props) {
  const { classroom } = props;
  const { schoolyear, school } = useSchoolSchoolyear();
  const updateClassroom = useUpdateClassroom(schoolyear.id, school.id);

  return (
    <div>
      <h5 tw="mb-2">{classroom.name}</h5>
      <WorkingDaysSelector
        key={classroom.id}
        value={classroom.workingDays}
        onChange={v => updateClassroom({ ...classroom, workingDays: v })}
      />
    </div>
  );
}
